import {DURATION} from './constants'

export const SESSION = {
  TYPE: {
    IMMEDIATE_VIRTUAL: 'immediate_virtual',
    SCHEDULED_VIRTUAL: 'scheduled_virtual',
  },
  MATCH: {
    FIRST_AVAILABLE: 'first_available',
    MANUAL: 'manual'
  },
  PLATFORM: {
    JEENIE: "jeenie",
    GOOGLE_MEET: "google_meet",
    ZOOM: "zoom",
    DOXY: "doxy",
    MS_TEAMS: "ms_teams",
    WHATSAPP: "whatsapp",
    RINGCENTRAL: "ringcentral",
    SKYPE: "skype",
    PSTN: "pstn",
    UNKNOWN: "unknown",
  },
  START: {
    NORMAL: 'normal', // customer initiated a new call
    RECONNECT: 'reconnect', // customer is attempting to connect again to their previous linguist
    RETRY_CANCEL: "retry_cancel", // customer is trying another call after the previous one was canceled by the remote user
    RETRY_FAILURE: 'retry_failure', // customer is trying another call after previous one failed to initially connect
    RETRY_TIMEOUT: 'retry_timeout', // customer is trying another call after previous one did not result in a match
    RETRY_DISCONNECT: 'retry_disconnect' // customer is trying another call after previous one was disconnected mid call
  },
  END: {
    DONE: 'done', // call ended normally by one side
    CANCEL: 'cancel', // call ended before connection was established between both sides
    TIMEOUT: 'timeout', // call ended because no linguist accepted the call within the time limit
    TIME_EXCEEDED: 'time_exceeded', // session had a hard time limit, so call was ended
    BALANCE_EXCEEDED: 'balance_exceeded', // paying customer's balance was empty, so call was ended
    FAILURE_LOCAL: 'failure_local', // call ended because local side failed to initially connect to the session
    FAILURE_REMOTE: 'failure_remote', // call ended because the remote side failed to initially connect to the session
    DISCONNECT_LOCAL: 'disconnect_local', // call ended because local side disconnected during the session
    DISCONNECT_REMOTE: 'disconnect_remote', // call ended because remote side disocnnected during the session
    ABORTED: 'aborted', // call was ended after creation by someone or a process other than the participants
    LEAVE: 'leave'
  },
  TIME: {
    MATCH: 60 * DURATION.SECOND, // time to wait for a linguist to accept call before considering session a timeout
    CONNECT: 60 * DURATION.SECOND, // time to wait before considering initial connction attempt a failure; keep this above 30s, because some OT errors will only fire after 30s
    RECONNECT: 10 * DURATION.SECOND, // time to wait before showing reconnection options
    END_SOON_WARNING: 2 * DURATION.MINUTE, // show warning that call is ending soon when this much time is remaining
    BALANCE_WARNING: 2 * DURATION.MINUTE,
  }
}

export const PARTICIPANT = {
  ROLE: {
    LINGUIST: 'linguist',
    CREATOR: 'creator',
    PARTICIPANT: 'participant',
    OBSERVER: 'observer'
  },
  PLATFORM: {
    MOBILE: 'solo_mobile',
    WEB: 'solo_web',
    PSTN: 'pstn',
  },
  STATUS: {
    CONNECTED: 'connected',
    CONNECTING: 'connecting',
    DISCONNECTED: 'disconnected',
  },
  STATUS_REASON: {
    INVITE_SENT: 'invite_sent',
    INVITE_FAILED_UNAVAILABLE: 'invite_failed_unavailable',
    INVITE_FAILED_ERROR: 'invite_failed_error',
    PARTICIPANT_DISCONNECTED: 'participant_disconnected',
    PARTICIPANT_REMOVED: 'participant_removed',
  }
}

export const OFF_PLATFORM = {
  ZOOM: {
    //MEETING_TYPE determines the type of zoom meeting user is trying to request an interpreter in 
    MEETING_TYPE: {
      INSTANT_MEETING: 1,
      SCHEDULED_MEETING: 2,
      RECURRING_MEETING_NO_FIXED_TIME: 3,
      PMI_MEETING: 4,
      RECURRING_MEETING_FIXED_TIME: 8,
    },
    //USER_TYPE determines the type of zoom account of current zoom user
    USER_TYPE: {
      BASIC: 1,
      LICENSED: 2,
      ON_PREM: 3,
      NONE: 99,  
    },
    // APPROVAL_TYPE determines registration type for scheduled meeting
    APPROVAL_TYPE: {
      AUTOMATICALLY_APPROVE: 0, 
      MANUALLY_APPROVE: 1, 
      NO_REGISTRATION_REQUIRED: 2,
    }
  }
}
